var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_437_15932)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M22 7.81V16.19C22 19 20.71 20.93 18.44 21.66C17.7142 21.8978 16.9537 22.0127 16.19 22H7.81C7.0463 22.0127 6.28585 21.8978 5.56 21.66C3.29 20.93 2 19 2 16.19V7.81C2 4.17 4.17 2 7.81 2H16.19C19.83 2 22 4.17 22 7.81Z",
    fill: "#97A1C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4396 21.66C17.7137 21.8978 16.9533 22.0127 16.1896 22H7.80957C7.04587 22.0127 6.28542 21.8978 5.55957 21.66C5.90957 19.02 8.66957 16.97 11.9996 16.97C15.3296 16.97 18.0896 19.02 18.4396 21.66Z",
    fill: "#97A1C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5799 11.58C15.5799 12.2881 15.37 12.9802 14.9766 13.5689C14.5832 14.1577 14.0241 14.6165 13.3699 14.8875C12.7158 15.1585 11.996 15.2293 11.3015 15.0912C10.607 14.9531 9.96915 14.6121 9.46848 14.1114C8.96781 13.6108 8.62685 12.9729 8.48871 12.2784C8.35058 11.584 8.42147 10.8642 8.69243 10.21C8.9634 9.55583 9.42225 8.99671 10.011 8.60334C10.5997 8.20996 11.2919 8 11.9999 8C12.949 8.00132 13.8588 8.37892 14.5299 9.05002C15.201 9.72111 15.5786 10.6309 15.5799 11.58Z",
    fill: "#97A1C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_437_15932"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload6);
export default __webpack_public_path__ + "static/media/download 6.38c10dd6781c412f336510e12685ff9d.svg";
export { ForwardRef as ReactComponent };